module.exports = __webpack_public_path__ + "img/visa-autre.6686575e.png";